import { SecondaryTags as View } from 'ui-components'
import { useGetCategoryTags } from '~explore/queries/useGetCategoryTags'
import { Category_Tag_Type } from '~explore/types/__generated/gql/graphql'

const SecondaryTags = () => {
  const { data = [], isLoading } = useGetCategoryTags({
    categoryTypes: [Category_Tag_Type.Secondary],
    size: 5
  })

  return (
    <View
      isLoading={isLoading}
      tags={data}
      getKey={(tag) => tag.id}
      getHref={(tag) => `/search?sort=all&tags=${tag.id}`}
      getCover={(tag) =>
        `https://${process.env.TAG_ASSETS_URL}/${tag.thumbnail}?${tag.updatedAt}`
      }
      getTitle={(tag) => tag.name}
    />
  )
}

export { SecondaryTags }
